module.exports = "/assets/459ede3db8735f77fc54f78f973b8490.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/5U.png
// module id = 2202
// module chunks = 0